import { AxiosRequestConfig, AxiosResponse } from 'axios';

import IdentityType from './constants/IdentityType';

export interface DaltonErrorResponseError {
    error?: string;
    field: string | null;
    message: string;
}

export interface DaltonErrorResponse {
    errors: DaltonErrorResponseError[];
}

export default class DaltonError {
    public config?: AxiosRequestConfig;
    public error?: string;
    public field: string | null;
    public message: string;
    public status?: number;

    public constructor(error: DaltonErrorResponseError, response?: AxiosResponse) {
        this.message = error.message || '';
        this.field = error.field;
        this.error = error.error;

        if (response) {
            this.config = response.config;
            this.status = response.status;
        }

        if (this.field === 'principal' && this.message.startsWith('[EMAIL]')) {
            this.field = 'emailAddress';
            this.message = this.message.substring('[EMAIL]'.length).trim();
        } else if (this.field === 'principal' && this.message.startsWith('[_INTERNAL]')) {
            this.field = 'username';
            this.message = this.message.substring('[_INTERNAL]'.length).trim();
        }

        if (!this.field && this.data) {
            switch (this.data.identityType) {
                case IdentityType.EMAIL:
                    this.field = 'emailAddress';
                    break;
                case IdentityType._INTERNAL:
                    this.field = 'username';
                    break;
            }
        }
    }

    public get data() {
        if (!this.config) {
            return undefined;
        }
        try {
            const data = JSON.parse(this.config.data);
            return data;
        } catch (error) {
            return this.config.data;
        }
    }

    public get method() {
        return this.config ? this.config.method : undefined;
    }

    public get url() {
        return this.config ? this.config.url : undefined;
    }
}
